import DeleteIconButton from '../../components/DeleteIconButton';
import EditOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment, Link, TextField, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
// import { useSnackbar } from '@mui/x-tree-view/TreeItem';
import { useSnackbar } from 'notistack';
import * as React from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import EditIcon from '@mui/icons-material/BorderColorOutlined';

import { DataAPIContext } from '../../api';
import { CREATE, DELETE, GET_LIST, GET_ONE, UPDATE } from '../../api/dataProvider';
import BlockRedirect from '../../components/BlockRedirect';
import { ContextStore } from '../../store/contextStore';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import FixedLinearProgress from '../../components/FixedLinearProgress';
import FormActionButtons from '../../components/FormActionButtons';
import { getLicenseeColumn } from '../../components/franchiseColumns';
import LicenseeFormField from '../../components/LicenseeFormField';
import RecordList from '../../components/RecordList';
import RemoteAutocomplete from '../../components/RemoteAutocomplete';
import { useIsWidthUp } from '../../utils';
import AccessGroupEdit from './AccessGroupEdit';
import AccessTagEdit from './AccessTagEdit';
import { CANCEL_CHANGES_MESSAGE, ConfirmationDialogText, LEAVE_WITHOUT_SAVING_MESSAGE } from './utils';
import useConfirmDialog from '../../components/useConfirmDialog';

const useStyles = makeStyles((theme) => ({
    gridRoot: {
        height: 'calc(100vh - 9.5rem)',
        [theme.breakpoints.down('sm')]: {
            height: 'calc(100vh - 11rem)',
        },
    },
    recordList: {
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
    },
    sortButton: {
        minWidth: theme.spacing(4),
        minHeight: theme.spacing(4),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        padding: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    groupList: {
        // borderRight: '1px solid lightgray',
    },
    mobileAccessGroupList: {
        width: '100%',
        padding: theme.spacing(1, 1.5, 2),
        overflowY: 'auto',
    },
    mobileAccessGroupCard: {
        border: '1px solid #e0e0e0',
        borderRadius: theme.spacing(1.5),
        padding: theme.spacing(1.25, 1.5),
        marginBottom: theme.spacing(1),
    },
    mobileAccessGroupName: {
        cursor: 'pointer',
        fontWeight: 600,
    },
    mobileAccessGroupHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
    },
    mobileAccessGroupMeta: {
        color: theme.palette.text.secondary,
        fontSize: 13,
        marginBottom: theme.spacing(0.75),
    },
    mobileAccessGroupChips: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        justifyContent: 'flex-end',
    },
    mobileAccessGroupActions: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: theme.spacing(0.5),
        alignItems: 'center',
    },
}));







const _listToTree = (nodes, cache) => {
    return (nodes || []).map((node) => {
        if (cache[node.id]) {
            node.items = _listToTree(cache[node.id], cache);
        } else {
            node.items = null;
        }
        return node;
    });
};

const dictToTree = (d, parent) => {
    const byParent = {};
    Object.keys(d).forEach((k) => {
        const x = d[k];
        if (!byParent[x.parent]) {
            byParent[x.parent] = [];
        }
        byParent[x.parent].push(x);
    });
    const nodes = _listToTree(byParent[null], byParent);
    return nodes;
};

const withFetchTimeout = (promise, ms, message) => {
    let timeoutId;
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(() => reject(new Error(message || 'Request timed out')), ms);
    });
    return Promise.race([promise, timeoutPromise]).finally(() => clearTimeout(timeoutId));
};

const AccessGroupsList = (props) => {
    const [confirmDelete, confirmDeleteDialog] = useConfirmDialog();
    const dataAPI = React.useContext(DataAPIContext);
    const { isFranchise, licensees, currentLicensee, hasPerm } = React.useContext(ContextStore);
    const urlParams = useParams();
    const urlSearchParams = new URLSearchParams(window?.location?.search);
    const history = useHistory();
    const classes = useStyles();
    const resource = 'access_group';
    const { enqueueSnackbar } = useSnackbar();
    const isSmallScreen = !useIsWidthUp('sm');
    const [nodeCache, setNodeCache] = React.useState(null);
    const [accessTags, setAccessTags] = React.useState(null);
    const [addNewGroupDialogOpen, setAddNewGroupDialogOpen] = React.useState(null);
    const [newGroupDialogParent, setNewGroupDialogParent] = React.useState(null);
    const currentAccessGroupId = urlParams.group_id;
    const currentAccessTagId = urlParams.tag_id;
    const [currentAccessGroup, setCurrentAccessGroup] = React.useState(null);
    const [currentAccessTag, setCurrentAccessTag] = React.useState(null);
    const [accessGroupDetailError, setAccessGroupDetailError] = React.useState(null);
    const [accessTagDetailError, setAccessTagDetailError] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);
    const [permissionList, setPermissionList] = React.useState(null);
    const [currentTab, setCurrentTab] = React.useState(
        urlSearchParams.get('access_type') === 'tags' || !!urlParams.tag_id ? 1 : 0
    );
    const permissionMap = {};
    const accessGroups = !!nodeCache ? dictToTree(nodeCache) : null;

    const [query, setQuery] = React.useState('');
    const tabOptions = [{ id: 0, name: 'Access groups' }, { id: 1, name: 'Access tags', }]
    const theme = useTheme();

    const [confirmationDialogAction, setConfirmationDialogAction] = React.useState(null);
    const [accessTagToBeDeleted, setAccessTagToBeDeleted] = React.useState(null);
    const [newTagDialogOpen, setNewTagDialogOpen] = React.useState(false);
    const [editTagDialogOpen, setEditTagDialogOpen] = React.useState(null);
    const [newTagName, setNewTagName] = React.useState('');
    const [newTagLicensee, setNewTagLicensee] = React.useState(currentLicensee || null);
    const roleChipBackgroundColor = React.useMemo(() => ({
        10: '#D8D8D8',
        78: '#DAF3E5',
        11: '#E4E4F9',
    }), []);

    React.useEffect(() => {
        if (urlParams.tag_id) {
            setCurrentTab(1);
        }
    }, [urlParams.tag_id]);

    // The create dialog opens on { name: '', atag: [], licensee: currentLicensee || null }, so
    // anything that differs from those defaults is work the user would lose on an accidental
    // close. The licensee has to be part of this: in franchise mode a parent admin can pick a
    // different one and that is the only edit they have made.
    const started_creating = !!addNewGroupDialogOpen && (
        !!addNewGroupDialogOpen.name
        || addNewGroupDialogOpen.atag?.length > 0
        || addNewGroupDialogOpen.licensee !== (currentLicensee || null)
    );
    const location = useLocation();
    const filteredAccessGroups = React.useMemo(() => {
        if (!accessGroups) {
            return [];
        }
        const normalizedQuery = (query || '').trim().toLowerCase();
        const filtered = normalizedQuery
            ? accessGroups.filter((ag) => ag.name.toLowerCase().includes(normalizedQuery))
            : accessGroups;
        return filtered.slice().sort((a, b) => a.name.localeCompare(b.name));
    }, [accessGroups, query]);

    const reloadAccessGroups = React.useCallback(() => {
        dataAPI(GET_LIST, resource, { pagination: { page: 1, perPage: 10000 } }).then((res) => {
            const nc = {};
            res.data?.forEach((x) => {
                nc[x.id] = x;
            });
            setNodeCache(nc);
        });
    }, [dataAPI, resource]);

    const reloadAccessTags = React.useCallback(() => {
        dataAPI(GET_LIST, 'access_tag', { pagination: { page: 1, perPage: 10000 } }).then((res) => {
            setAccessTags(res.data);
        });
    }, [dataAPI]);



    if (permissionList !== null) {
        permissionList?.forEach((x) => {
            const c = x.codename.split('.');
            if (c.length !== 2) {
                return;
            }
            const scope = c[0];
            const action = c[1];
            const perm = { ...x, scope, action };
            if (!permissionMap[scope]) {
                permissionMap[scope] = {};
            }
            permissionMap[scope][action] = perm;
        });
    }



    React.useEffect(() => {
        if (accessGroups !== null) {
            return;
        }
        dataAPI(GET_LIST, resource, { pagination: { page: 1, perPage: 10000 } }).then((res) => {
            // const nodes = listToTree(res.data, null);
            // setAccessGroups(nodes);
            const nc = {};
            res.data?.forEach((x) => {
                nc[x.id] = x;
            });
            console.log('node nc', nc);
            setNodeCache(nc);
            // const nodes = dictToTree(nc, null);
            // setAccessGroups(nodes);
        }).finally(() => setIsLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (accessTags !== null) {
            return;
        }
        dataAPI(GET_LIST, 'access_tag', { pagination: { page: 1, perPage: 10000 } }).then((res) => {
            setAccessTags(res.data);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (permissionList !== null) {
            return;
        }
        console.log('node fetching perm list');
        dataAPI(GET_LIST, 'permission', { pagination: { page: 1, perPage: 10000 } }).then((res) => {
            console.log('node fetched perm list', res.data);
            setPermissionList(res.data);
        });
    }, []);


    const onNodeDeleteClick = (ev, ag) => {
        ev.preventDefault();
        confirmDelete({ body: `Are you sure you want to delete access group ${ag.name} with ${ag.member_count} members?` }).then((ok) => {
            if (ok) {
                console.log('node delete', ag);
                doDeleteAccessGroup(ag.id);
            }
        });
        return false;
    };


    const doDeleteAccessGroup = (ag_id) => {
        dataAPI(DELETE, resource, { id: ag_id }).then((res) => {
            console.log('node res', res);
            setNodeCache((prevState) => {
                const newState = { ...prevState };
                delete newState[ag_id];
                console.log('node new state', newState);
                return newState;
            });
        });
    };

    const addNewAccessGroup = (raw_ag) => {
        dataAPI(CREATE, resource, { id: null, data: raw_ag }).then((res) => {
            if (res.statusCode === 400) {
                enqueueSnackbar(`Error: ${res.data.message}`, { variant: 'error' });
            } else if (res.statusCode === 201) {
                setNodeCache((prevState) => ({
                    ...prevState,
                    [res.data.id]: { ...res.data, items: null },
                }));
                enqueueSnackbar(`New access group "${raw_ag.name}" added`, { variant: 'success' });
            } else {
                if (res.data?.message) {
                    enqueueSnackbar(`Error: ${res.data.message}`, { variant: 'error' });
                } else {
                    enqueueSnackbar(`Error: unexpected HTTP status: ${res.statusCode}`, { variant: 'error' });
                }
            }
        });
    };

    // React.useEffect(() => {
    //     if (nodeCache === null) { return; }
    //     const dtt = dictToTree(nodeCache);
    //     console.log('node setAccessGroups', dtt);
    //     setAccessGroups(dtt);
    // }, [nodeCache]);

    React.useEffect(() => {
        if (!currentAccessGroupId) {
            setCurrentAccessGroup(null);
            setAccessGroupDetailError(null);
            return;
        }
        const requestedId = String(currentAccessGroupId);
        let cancelled = false;
        setAccessGroupDetailError(null);
        setIsLoading(true);
        withFetchTimeout(dataAPI(GET_ONE, resource, { id: currentAccessGroupId }), 90000, 'Loading access group timed out')
            .then((res) => {
                if (cancelled) {
                    return;
                }
                const ok =
                    res.statusCode === 200 &&
                    res.data &&
                    res.data.id != null &&
                    String(res.data.id) === requestedId;
                if (ok) {
                    setCurrentAccessGroup(res.data);
                } else {
                    setCurrentAccessGroup(null);
                    const msg =
                        res.statusCode >= 400
                            ? res.data?.message || 'Could not load access group'
                            : 'Could not load access group';
                    setAccessGroupDetailError(msg);
                    enqueueSnackbar(msg, { variant: 'error' });
                }
            })
            .catch((err) => {
                if (cancelled) {
                    return;
                }
                setCurrentAccessGroup(null);
                const msg = err?.message || 'Could not load access group';
                setAccessGroupDetailError(msg);
                enqueueSnackbar(msg, { variant: 'error' });
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [dataAPI, currentAccessGroupId, enqueueSnackbar, resource]);

    React.useEffect(() => {
        if (!currentAccessTagId) {
            setCurrentAccessTag(null);
            setAccessTagDetailError(null);
            return;
        }
        const requestedId = String(currentAccessTagId);
        let cancelled = false;
        setAccessTagDetailError(null);
        setIsLoading(true);
        withFetchTimeout(dataAPI(GET_ONE, 'access_tag', { id: currentAccessTagId }), 90000, 'Loading access tag timed out')
            .then((res) => {
                if (cancelled) {
                    return;
                }
                const ok =
                    res.statusCode === 200 &&
                    res.data &&
                    res.data.id != null &&
                    String(res.data.id) === requestedId;
                if (ok) {
                    setCurrentAccessTag(res.data);
                } else {
                    setCurrentAccessTag(null);
                    const msg =
                        res.statusCode >= 400
                            ? res.data?.message || 'Could not load access tag'
                            : 'Could not load access tag';
                    setAccessTagDetailError(msg);
                    enqueueSnackbar(msg, { variant: 'error' });
                }
            })
            .catch((err) => {
                if (cancelled) {
                    return;
                }
                setCurrentAccessTag(null);
                const msg = err?.message || 'Could not load access tag';
                setAccessTagDetailError(msg);
                enqueueSnackbar(msg, { variant: 'error' });
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [dataAPI, currentAccessTagId, enqueueSnackbar]);

    const onAddNewGroup = (ev) => {
        const data = {
            ...addNewGroupDialogOpen,
            atag_ids: addNewGroupDialogOpen.atag.map((x) => x.id),
        };
        if (data.parent === 0) {
            data.parent = null;
        }
        delete data['atag'];
        addNewAccessGroup(data);
        setAddNewGroupDialogOpen(null);
    };

    const onNodeSelect = (ev, nid) => {
        const inid = parseInt(nid, 10);
        if (inid <= 0) {
            const parent_id = Math.abs(inid);
            const ag = parent_id > 0 ? nodeCache[parent_id] : null;
            console.log('node select: ag', ag, inid, parent_id, nodeCache);
            setNewGroupDialogParent(ag);
            setAddNewGroupDialogOpen({ id: null, name: '', parent: parent_id, atag: [], licensee: currentLicensee || null });
            // const name = prompt("Enter new access group's name");
            // if (name && name.length > 0) {
            //     addNewAccessGroup({ id: null, name: name, parent: parent_id, atag_ids:  })
            // }
        } else {
            // setCurrentAccessGroupId(inid);
            console.log('node compare', inid, urlParams.group_id);
            if (inid !== parseInt(urlParams.group_id)) {
                console.log('node pushing new details url', inid);
                history.push(`/user/permissions/group/${inid}`);
                setCurrentAccessGroup(null);
            } else {
                history.push('/user/permissions');
                setCurrentAccessGroup(null);
            }
        }
    };


    const handleAddNewGroupDialogClose = () => {
        if (started_creating && !window.confirm(LEAVE_WITHOUT_SAVING_MESSAGE)) {
            return;
        }
        setAddNewGroupDialogOpen(null);
    };

    const onNewGroupTextChange = (ev) => {
        // Read the input now, not inside the updater: React defers the updater to render
        // when other updates are queued, and by then it has reset the controlled input to
        // the last committed value, so the keystroke would be read back as ''.
        const { name, value } = ev.target;
        setAddNewGroupDialogOpen((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const onNewGroupAccessTagChange = (ev, selected, reason) => {
        // console.log('node atag change', selected);
        setAddNewGroupDialogOpen((prevState) => ({
            ...prevState,
            atag: selected,
        }));
    };

    const onAccessGroupUpdate = (ag) => {
        setNodeCache((prevState) => ({
            ...prevState,
            [ag.id]: ag,
        }));
    };

    const onAccessGroupClose = () => {
        // Navigate first: AccessGroupEdit's unsaved-changes prompt can refuse it, and
        // BlockRedirect answers synchronously, so an unchanged location means the user
        // chose to stay. Clearing the group before asking unmounted the editor either way,
        // losing the edits and stranding the URL on a spinner that never resolved.
        const from = history.location;
        history.push(currentTab === 1 ? '/user/permissions?access_type=tags' : '/user/permissions');
        if (history.location === from) {
            return;
        }
        props.setNavigateBackBarData && props.setNavigateBackBarData({ title: 'Roles & Permissions', addAction: currentTab === 0 ? () => onNodeSelect("ev", 0) : () => onAddNewAccessTag(), buttonText: currentTab === 0 ? 'New access group' : "New access tag" })
        setCurrentAccessGroup(null);
    };

    const onAccessTagClose = () => {
        props.setNavigateBackBarData && props.setNavigateBackBarData({ title: 'Roles & Permissions', addAction: currentTab === 0 ? () => onNodeSelect("ev", 0) : () => onAddNewAccessTag(), buttonText: currentTab === 0 ? 'New access group' : "New access tag" })
        setCurrentAccessTag(null);
        history.push(currentTab === 1 ? '/user/permissions?access_type=tags' : '/user/permissions');
    };

    const onAddNewAccessTag = () => {
        setNewTagName('');
        setNewTagLicensee(currentLicensee || null);
        setNewTagDialogOpen(true);
    };

    // Same defaults onAddNewAccessTag seeds, so anything else is work the [CANCEL] would lose.
    const started_creating_tag = !!newTagName.trim() || newTagLicensee !== (currentLicensee || null);

    const handleNewTagDialogClose = () => {
        if (started_creating_tag && !window.confirm(CANCEL_CHANGES_MESSAGE)) {
            return;
        }
        setNewTagDialogOpen(false);
    };

    const onConfirmNewAccessTag = () => {
        const name = newTagName.trim();
        if (!name) {
            return enqueueSnackbar('Access tag must have a name', { variant: 'error' });
        }
        if (accessTags?.filter((x) => x.name === name).length > 0) {
            return enqueueSnackbar('Access tag names must be unique', { variant: 'error' });
        }
        setNewTagDialogOpen(false);
        setIsLoading(true);
        const data = { name };
        if (isFranchise && newTagLicensee) {
            data.tour_operator = newTagLicensee;
        }
        dataAPI(CREATE, 'access_tag', { id: null, data })
            .then((res) => {
                setAccessTags((prevState) => prevState.concat(res.data));
                enqueueSnackbar(`Access tag "${name}" created successfully`, { variant: 'success' });
            })
            .finally(() => setIsLoading(false));
    };

    React.useEffect(() => {
        if (currentAccessGroupId || currentAccessTagId) {
            return;
        }
        const url_search_params = new URLSearchParams(location.search);
        const onPermissionsPath = location.pathname.includes('/user/permissions');
        if (parseInt(url_search_params.get('tab'), 10) === 2 || onPermissionsPath) {
            props.setNavigateBackBarData &&
                props.setNavigateBackBarData({
                    title: 'Roles & Permissions',
                    addAction: currentTab === 0 ? () => onNodeSelect('ev', 0) : () => onAddNewAccessTag(),
                    buttonText: currentTab === 0 ? 'New access group' : 'New access tag',
                });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- props.setNavigateBackBarData omitted to avoid parent-driven loops
    }, [location, currentAccessGroupId, currentAccessTagId, currentTab]);

    React.useEffect(() => {
        if (currentAccessGroupId || currentAccessTagId) {
            return;
        }
        const t = setTimeout(() => {
            props.setNavigateBackBarData &&
                props.setNavigateBackBarData({
                    title: 'Roles & Permissions',
                    addAction: currentTab === 0 ? () => onNodeSelect('ev', 0) : () => onAddNewAccessTag(),
                    buttonText: currentTab === 0 ? 'New access group' : 'New access tag',
                });
        }, 50);
        return () => clearTimeout(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTab, currentAccessGroupId, currentAccessTagId]);

    // CP-5260: this was a window.prompt, whose [Cancel] cannot be intercepted, so a mistyped
    // rename vanished with no way to ask about it. A real dialog can guard the dismissal.
    const onEditAccessTag = (ev, atag) => {
        setEditTagDialogOpen({ id: atag.id, originalName: atag.name, name: atag.name });
    };

    const editing_tag = !!editTagDialogOpen && editTagDialogOpen.name !== editTagDialogOpen.originalName;
    // CP-8441: SAVE needs a non-empty name that differs from the one the tag already has.
    const canSaveEditedTag = !!editTagDialogOpen && !!editTagDialogOpen.name.trim() && editTagDialogOpen.name.trim() !== editTagDialogOpen.originalName;

    const handleEditTagDialogClose = () => {
        if (editing_tag && !window.confirm(CANCEL_CHANGES_MESSAGE)) {
            return;
        }
        setEditTagDialogOpen(null);
    };

    const onConfirmEditAccessTag = () => {
        const { id, originalName } = editTagDialogOpen;
        const name = editTagDialogOpen.name.trim();
        if (!name) {
            return enqueueSnackbar("Access tag name can't be empty", { variant: 'warning' });
        }
        if (accessTags?.filter((x) => x.name === name && x.id !== id).length > 0) {
            return enqueueSnackbar('Access tag names must be unique', { variant: 'error' });
        }
        setEditTagDialogOpen(null);
        setIsLoading(true);
        dataAPI(UPDATE, 'access_tag', { id, data: { name } })
            .then((res) => {
                if (res.statusCode === 200) {
                    setAccessTags((prevState) => prevState.map((x) => (x.id !== id ? x : res.data)));
                    enqueueSnackbar(`Access tag "${originalName}" renamed to "${res.data.name}"`, { variant: 'success' });
                } else {
                    enqueueSnackbar(`Error updating access tag "${originalName}"`, { variant: 'error' });
                }
            })
            .finally(() => setIsLoading(false));
    };

    // CP-7771: the backend answers 204 when the tag is gone, or 200 {message, refs: [{name, count}]} when records
    // still carry it, and deletes it then only with `force`. Both answers were never seen before: the delete
    // ran without the check. The tag is removed from the list only after a 204.
    const onDeleteAccessTag = async (ev, atag) => {
        setIsLoading(true);
        const removed = () => {
            setAccessTags((prevState) => prevState.filter((x) => x.id !== atag.id));
            enqueueSnackbar(`Access tag "${atag.name}" removed successfully`, { variant: 'success' });
        };
        const failed = (res) => enqueueSnackbar(res?.data?.message || `Error deleting access tag "${atag.name}"`, { variant: 'error' });
        try {
            const res = await dataAPI(DELETE, 'access_tag', { id: atag.id });
            if (res?.statusCode === 204) {
                removed();
            } else if (res?.statusCode === 200) {
                const refs = Array.isArray(res.data?.refs) ? res.data.refs : [];
                const count = refs.reduce((acc, ref) => acc + (ref.count || 0), 0);
                const where = refs.map((ref) => `${ref.count} ${ref.name}`).join(', ');
                const confirmed = await confirmDelete({
                    body: `Access tag ${atag.name} is used by ${count} record${count === 1 ? '' : 's'}${where ? ` (${where})` : ''}. `
                        + 'Deleting it removes the tag from all of them, which changes who can see them. Delete it anyway?',
                });
                if (confirmed) {
                    const forced = await dataAPI(DELETE, 'access_tag', { id: atag.id, data: { force: true } });
                    if (forced?.statusCode === 204) {
                        removed();
                    } else {
                        failed(forced);
                    }
                }
            } else {
                failed(res);
            }
        } finally {
            setIsLoading(false);
            setAccessTagToBeDeleted(null);
        }
    };

    const onAccessTagSelect = (ev, atag) => {
        history.push(`/user/permissions/tag/${atag.id}`);
        setCurrentAccessGroup(null);
    };


    const confirmationDialogCancel = () => {
        setConfirmationDialogAction(null);
        setAccessTagToBeDeleted(null)
    };

    const confirmationDialogConfirm = (access_tag) => {
        switch (confirmationDialogAction) {
            case 'delete_access_tag':
                onDeleteAccessTag('event', accessTagToBeDeleted)
                break;
            default:
                break;
        }
        confirmationDialogCancel();
    };


    const handleDeleteAccessTag = (access_tag) => {
        setAccessTagToBeDeleted(access_tag)
        setConfirmationDialogAction('delete_access_tag');
    }

    const handleTabChange = (tab_id) => {
        setCurrentTab(tab_id);
        history.push(tab_id === 1 ? '/user/permissions?access_type=tags' : '/user/permissions');
    };

    return (
        <>
            {confirmDeleteDialog}
            <BlockRedirect shouldBlock={started_creating} message={LEAVE_WITHOUT_SAVING_MESSAGE} />
            <Dialog open={!!addNewGroupDialogOpen} onClose={handleAddNewGroupDialogClose}>
                {!!addNewGroupDialogOpen && (
                    <>
                        <DialogTitle>
                            Create New {newGroupDialogParent ? 'Nested ' : ''}Access Group{newGroupDialogParent ? ` under ${newGroupDialogParent.name}` : null}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container direction="row" spacing={2}>
                                <Grid item xs={12}>
                                    <DialogContentText>Please enter a name for the new group and select at least one access tag</DialogContentText>
                                </Grid>
                                <Grid item xs={12}>
                                    <LicenseeFormField
                                        value={addNewGroupDialogOpen?.licensee}
                                        onChange={(id) => setAddNewGroupDialogOpen((prev) => prev ? { ...prev, licensee: id } : prev)}
                                        allowNone={hasPerm('franchise', 'manager')}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField autoFocus margin="dense" name="name" label="Group name" type="name" fullWidth variant="standard" value={addNewGroupDialogOpen?.name} onChange={onNewGroupTextChange} />
                                </Grid>
                                <Grid item xs={12}>
                                    <RemoteAutocomplete multiple resource="access_tag" urlSuffix={null} label="Access tags" variant="standard" size="small" fullWidth onChange={onNewGroupAccessTagChange} filterSelected apiParams={props.apiParams} value={addNewGroupDialogOpen?.atag} />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ px: 3, pb: 2 }}>
                            <FormActionButtons
                                onSubmit={onAddNewGroup}
                                // Same gate as the other create forms: CREATE stays off until the required
                                // fields are filled -- a name (the API refuses an empty one) and, for users
                                // who can't pick "None (parent operator)", a licensee.
                                submitDisabled={!(addNewGroupDialogOpen?.name ?? '').trim() || (isFranchise && !hasPerm('franchise', 'manager') && !addNewGroupDialogOpen?.licensee)}
                                onCancel={handleAddNewGroupDialogClose}
                                size="medium"
                            />
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {confirmationDialogAction ? (
                <ConfirmationDialog
                    classes={{ paper: classes.paper }}
                    keepMounted
                    onCancel={confirmationDialogCancel}
                    onConfirm={confirmationDialogConfirm}
                    title={ConfirmationDialogText[confirmationDialogAction].title}
                    okButtonText={ConfirmationDialogText[confirmationDialogAction].okButtonText}
                    cancelButtonText={ConfirmationDialogText[confirmationDialogAction].cancelButtonText}
                    open={!!confirmationDialogAction}
                >
                    {ConfirmationDialogText[confirmationDialogAction].body}
                </ConfirmationDialog>
            ) : null}
            <Dialog open={newTagDialogOpen} onClose={handleNewTagDialogClose} maxWidth="xs" fullWidth>
                {newTagDialogOpen && (
                <>
                <DialogTitle>Create New Access Tag</DialogTitle>
                <DialogContent>
                    <LicenseeFormField value={newTagLicensee} onChange={setNewTagLicensee} />
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        fullWidth
                        variant="filled"
                        size="small"
                        value={newTagName}
                        onChange={(e) => setNewTagName(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && newTagName.trim()) onConfirmNewAccessTag(); }}
                        sx={{ mt: isFranchise ? 2 : 0 }}
                    />
                </DialogContent>
                <DialogActions>
                    <FormActionButtons
                        onSubmit={onConfirmNewAccessTag}
                        submitDisabled={!newTagName.trim() || (isFranchise && !newTagLicensee)}
                        onCancel={handleNewTagDialogClose}
                        size="medium"
                    />
                </DialogActions>
                </>
                )}
            </Dialog>
            <Dialog open={!!editTagDialogOpen} onClose={handleEditTagDialogClose} maxWidth="xs" fullWidth>
                {!!editTagDialogOpen && (
                <>
                <DialogTitle>Edit Access Tag</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        fullWidth
                        variant="filled"
                        size="small"
                        value={editTagDialogOpen?.name ?? ''}
                        onChange={(e) => {
                            const { value } = e.target; // read before the updater; see onNewGroupTextChange
                            setEditTagDialogOpen((prev) => (prev ? { ...prev, name: value } : prev));
                        }}
                        onKeyDown={(e) => { if (e.key === 'Enter' && canSaveEditedTag) onConfirmEditAccessTag(); }}
                    />
                </DialogContent>
                <DialogActions>
                    <FormActionButtons
                        mode="edit"
                        onSubmit={onConfirmEditAccessTag}
                        submitDisabled={!canSaveEditedTag}
                        onCancel={handleEditTagDialogClose}
                        size="medium"
                    />
                </DialogActions>
                </>
                )}
            </Dialog>
            <FixedLinearProgress visibility={!accessGroups || isLoading} />
            <div style={{ border: 'solid 1px #d8d8d8', borderTop: 'none', borderRadius: window.location.href.includes('permissions/') ? '16px' : '0 0 16px 16px', maxHeight: `calc(${theme.cp.contentHeight} - 5rem)`, overflow: 'auto' }}>
                {!currentAccessGroup && !currentAccessTag && !currentAccessGroupId && !currentAccessTagId &&
                    <Grid container justifyContent="flex-start" alignItems="flex-start" direction="row" spacing={0} className={classes.gridRoot} >
                        <Grid item xs={12} container justifyContent="space-between" alignItems="center" alignContent="center" p={2} style={{ height: isSmallScreen ? '102px' : '72px' }}>
                            <Grid item xs={12} sm={5} >
                                <TextField variant="filled" size="small" label="Search" style={{ maxWidth: 400 }} value={query} fullWidth onChange={(ev) => setQuery(ev.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={7} container justifyContent={isSmallScreen ? 'space-between' : "flex-end"} pt={isSmallScreen ? 1 : 0} alignItems="center">
                                {!isLoading && tabOptions.map((tab) => {
                                    return (
                                        <Grid
                                            item
                                            xs={'auto'}
                                            style={{
                                                padding: '6px 16px',
                                                borderRadius: '20px',
                                                backgroundColor: currentTab === tab.id ? "#007AFF" : 'white',
                                                color: currentTab === tab.id ? 'white' : 'rgba(0, 0, 0, 0.87)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '32px',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                border: 'solid 1px lightgrey',
                                                marginRight: tab.id === 0 ? '8px' : 0,
                                            }}
                                            key={tab.id}
                                            onClick={(ev) => handleTabChange(tab.id)}
                                        >
                                            <Typography fontSize={16}>
                                                {tab.name} ({accessGroups && accessTags && (tab.id === 0 ? accessGroups.length : accessTags.length)})
                                            </Typography>

                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                        {isLoading && <Grid item xs={12}><div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30vh' }}><CircularProgress /></div></Grid>}
                        {currentTab === 0 && !isLoading &&
                            <Grid item xs={12} container alignItems="flex-start" alignContent="flex-start" justifyContent="flex-start" style={{ height: isSmallScreen ? 'calc(100vh - 18rem)' : 'calc(100vh - 14rem)', }} >
                                {isSmallScreen ? (
                                    <div className={classes.mobileAccessGroupList}>
                                        {filteredAccessGroups.map((ag) => (
                                            <div key={ag.id} className={classes.mobileAccessGroupCard}>
                                                <div className={classes.mobileAccessGroupHeader}>
                                                    <Typography
                                                        className={classes.mobileAccessGroupName}
                                                        onClick={(e) => onNodeSelect(e, ag.id)}
                                                    >
                                                        {ag.name}
                                                    </Typography>
                                                    {Boolean(ag.managed && ag.template) && (
                                                        <Chip
                                                            size="small"
                                                            color="primary"
                                                            variant="outlined"
                                                            label="managed"
                                                            sx={{ borderRadius: '4px', height: '24px' }}
                                                        />
                                                    )}
                                                    {!!ag.propagated_roles?.length && (
                                                        <div className={classes.mobileAccessGroupChips}>
                                                            {ag.propagated_roles.map((role) => (
                                                                <Chip
                                                                    key={`${ag.id}-${role.id || role.name}`}
                                                                    size="small"
                                                                    label={role.name}
                                                                    sx={{
                                                                        borderRadius: '4px',
                                                                        height: '24px',
                                                                        '& .MuiChip-label': { px: 1, fontSize: '0.875rem' },
                                                                        backgroundColor: roleChipBackgroundColor[role.id] || '#E0E0E0',
                                                                    }}
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                {!!ag.codename && (
                                                    <Typography className={classes.mobileAccessGroupMeta}>
                                                        Code name: {ag.codename}
                                                    </Typography>
                                                )}
                                                {isFranchise && ag.licensee && (
                                                    <Typography className={classes.mobileAccessGroupMeta}>
                                                        Licensee: {ag.licensee.name}
                                                    </Typography>
                                                )}
                                                <div className={classes.mobileAccessGroupActions}>
                                                    <Tooltip title="Edit access group">
                                                        <span>
                                                            <Link
                                                                href={`/user/permissions/group/${ag.id}`}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    onNodeSelect(e, ag.id);
                                                                }}
                                                            >
                                                                <IconButton size="small" aria-label="Edit access group">
                                                                    <EditOutlinedIcon fontSize="small" color="primary" />
                                                                </IconButton>
                                                            </Link>
                                                        </span>
                                                    </Tooltip>
                                                    <DeleteIconButton
                                                        title={ag.managed && ag.template ? 'Managed groups can only be deleted by TourOptima staff' : 'Delete access group'}
                                                        aria-label="Delete access group"
                                                        perm="agroup.delete"
                                                        disabled={ag.created || Boolean(ag.managed && ag.template)}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            onNodeDeleteClick(e, ag);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <RecordList
                                        className={classes.recordList}
                                        disableSelectionOnClick={true}
                                        sortModel={[{ field: 'name', sort: 'asc' }]}
                                        sx={{ height: 'calc(100vh - 40rem) !important' }}
                                        disableListBorder={true}
                                        checkboxSelection={false}
                                        autorefresh
                                        onAutoRefreshTick={reloadAccessGroups}
                                        staticOptions={filteredAccessGroups}
                                        columns={[
                                            {
                                                field: 'name',
                                                headerName: 'Name',
                                                sortable: false,
                                                flex: 2,
                                                minWidth: 300,
                                                renderCell: (p) => {
                                                    return (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                            <Typography>{p.row.name}</Typography>
                                                            {Boolean(p.row.managed && p.row.template) && (
                                                                <Tooltip title="Managed by TourOptima staff — settings and permissions are read-only; members can still be edited.">
                                                                    <Chip size="small" color="primary" variant="outlined" label="managed" />
                                                                </Tooltip>
                                                            )}
                                                        </div>
                                                    );
                                                },
                                            },
                                            {
                                                field: 'codename',
                                                headerName: 'Code name',
                                                flex: 1,
                                                minWidth: 100,
                                                sortable: false,
                                            },
                                            ...(isFranchise ? [{
                                                field: 'licensee',
                                                headerName: 'Licensee',
                                                flex: 1,
                                                minWidth: 120,
                                                sortable: false,
                                                valueGetter: (p) => p.row.licensee?.name || '',
                                            }] : []),
                                            {
                                                field: 'roles',
                                                headerName: 'Roles (legacy)',
                                                sortable: false,
                                                flex: 1,
                                                minWidth: 100,
                                                valueGetter: (p) => {
                                                    return (p.row.roles || []).map(x => x.name).join(', ')
                                                }
                                            },
                                            {
                                                field: 'propagated_roles',
                                                headerName: 'Propagated roles',
                                                flex: 1,
                                                minWidth: 100,
                                                sortable: false,
                                                valueGetter: (p) => {
                                                    return (p.row.propagated_roles || []).map(x => x.name).join(', ')
                                                }
                                            },
                                            {
                                                field: 'buttons',
                                                headerName: 'Action',
                                                sortable: false,
                                                width: 125,
                                                renderCell: (p) => {
                                                    return (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '0.35rem',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            <Tooltip title="Edit access group">
                                                                <span>
                                                                    <Link
                                                                        href={`/user/permissions/group/${p.row.id}`}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            onNodeSelect(e, p.row.id)
                                                                        }}>
                                                                        <IconButton color="primary"><EditIcon fontSize="small" /></IconButton>
                                                                    </Link>
                                                                </span>
                                                            </Tooltip>
                                                            <DeleteIconButton
                                                                title={p.row.managed && p.row.template ? 'Managed groups can only be deleted by TourOptima staff' : 'Delete access group'}
                                                                perm="agroup.delete"
                                                                size="medium"
                                                                disabled={p.row.created || Boolean(p.row.managed && p.row.template)}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    onNodeDeleteClick(e, p.row)
                                                                }}
                                                            />
                                                        </div>
                                                    );
                                                },
                                            },
                                        ]}
                                    />
                                )}
                            </Grid>
                        }
                        {currentTab === 1 && !isLoading && 
                            <Grid item xs={12} container alignItems="flex-start" alignContent="flex-start" justifyContent="flex-start" style={{ height: isSmallScreen ? 'calc(100vh - 18rem)' : 'calc(100vh - 14rem)', }} >
                                <RecordList
                                    className={classes.recordList}
                                    disableSelectionOnClick={true}
                                    sortModel={[{ field: 'name', sort: 'asc' }]}
                                    sx={{ height: 'calc(100vh - 40rem) !important' }}
                                    disableListBorder={true}
                                    checkboxSelection={false}
                                    autorefresh
                                    onAutoRefreshTick={reloadAccessTags}
                                    staticOptions={query ? accessTags.filter(ag => ag.name.toLowerCase().includes(query.toLowerCase())) : accessTags}
                                    columns={[
                                        ...getLicenseeColumn(isFranchise, licensees, currentLicensee),
                                        {
                                            field: 'name',
                                            headerName: 'Name',
                                            sortable: false,
                                            flex: 0.6,
                                            renderCell: (p, e) => {
                                                return (
                                                    <span style={{ cursor: 'pointer' }} onClick={() => onAccessTagSelect(e, p.row)}>
                                                        <Typography>{p.row.name}</Typography>
                                                    </span>
                                                );
                                            },
                                        },
                                        {
                                            field: 'buttons',
                                            headerName: 'Action',
                                            sortable: false,
                                            width: 125,
                                            renderCell: (p) => {
                                                return (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '0.35rem',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <Tooltip title="Edit access tag">
                                                            <span>
                                                                <IconButton
                                                                    color="primary"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        onEditAccessTag(e, p.row)
                                                                    }}
                                                                >
                                                                    <EditIcon fontSize="small" />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        <DeleteIconButton
                                                            title="Delete access tag"
                                                            perm="atag.delete"
                                                            size="medium"
                                                            disabled={p.row.created}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleDeleteAccessTag(p.row)
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            },
                                        },
                                    ]}
                                />
                            </Grid>
                        }
                    </Grid>}
                {(currentAccessGroupId || currentAccessTagId) &&
                    !currentAccessGroup &&
                    !currentAccessTag &&
                    !accessGroupDetailError &&
                    !accessTagDetailError && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30vh' }}>
                        <CircularProgress />
                    </div>
                )}
                {currentAccessGroupId && !currentAccessGroup && accessGroupDetailError && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, minHeight: '30vh' }}>
                        <Typography color="error" align="center">
                            {accessGroupDetailError}
                        </Typography>
                        <Button variant="outlined" color="primary" onClick={() => history.push('/user/permissions')}>
                            Back to access groups
                        </Button>
                    </div>
                )}
                {currentAccessTagId && !currentAccessTag && accessTagDetailError && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, minHeight: '30vh' }}>
                        <Typography color="error" align="center">
                            {accessTagDetailError}
                        </Typography>
                        <Button variant="outlined" color="primary" onClick={() => history.push('/user/permissions?access_type=tags')}>
                            Back to access tags
                        </Button>
                    </div>
                )}
                {currentAccessGroup && (
                    <Grid item xs={12}>
                        <AccessGroupEdit setNavigateBackBarData={props.setNavigateBackBarData} resource={resource} data={currentAccessGroup} permissionList={permissionList} permissionMap={permissionMap} isSmallScreen={isSmallScreen} onAccessGroupUpdate={onAccessGroupUpdate} onClose={onAccessGroupClose} />
                    </Grid>
                )}
                {currentAccessTag && (
                    <Grid item xs={12}>
                        <AccessTagEdit setNavigateBackBarData={props.setNavigateBackBarData} resource={'access_tag'} data={currentAccessTag} permissionList={permissionList} permissionMap={permissionMap} isSmallScreen={isSmallScreen} onClose={onAccessTagClose} />
                    </Grid>
                )}
            </div>
        </>
    );
};

export default AccessGroupsList;
